import { useQuery } from '@tanstack/react-query';
import { SitterProfileResponse } from 'happypaws-shared/src/Sitter/models/SitterProfileResponse';
import { api } from '../../services/api';

export const useGetSitterProfile = () => {
  return useQuery({
    queryKey: ['sitterProfile'],
    queryFn: async () => {
      const response = await api.get<SitterProfileResponse>('/sitters/profile');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
